module.exports = __webpack_public_path__ + "img/device_logo_connected.a15aaab2.png";